import React, { createContext, useContext, useState } from 'react';

const SidebarCtx = createContext({ mobileOpen: false, setMobileOpen: () => {} });

export function SidebarProvider({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <SidebarCtx.Provider value={{ mobileOpen, setMobileOpen }}>{children}</SidebarCtx.Provider>
  );
}

export function useSidebar() {
  return useContext(SidebarCtx);
}
